export enum FavouriteRouteType {
  STOP = 'STOP',
  POSITION = 'POSITION',
}
